import $ from "jquery";
import {classes} from "mojave/classes";
import {Component, h} from "preact";
import {formatAmount} from "../../../lib/price";
import {ICON_RADIO, ICON_RADIO_CHECKED} from "../../../lib/icons";


/**
 * @typedef {{
 *      runtime: Membership.Runtime,
 *      selected: number,
 *      onSelect: function(),
 *      isFirstEntry: boolean,
 *      isLastEntry: boolean,
 * }} RuntimeDetails.Props
 *
 * @typedef {{
 * }} RuntimeDetails.State
 */
export class RuntimeDetails extends Component
{
	/**
	 * @private
	 * @type {boolean}
	 */
	descriptionsOpened = false;


	/**
	 * @inheritDoc
	 * @param {RuntimeDetails.Props} nextProps
	 */
	componentWillReceiveProps (nextProps)
	{
		/** @type {RuntimeDetails.Props} props */
		const props = this.props;

		const wasActive = props.selected === props.runtime.id;
		const isActive = nextProps.selected === nextProps.runtime.id;

		if (wasActive !== isActive)
		{
			const $content = $(this.base).find("._membership-runtime-content");
			const method = isActive ? "slideDown" : "slideUp";
			$content.stop(true)[method]();
		}
	}


	/**
	 * @param {RuntimeDetails.Props} props
	 * @param {RuntimeDetails.State} state
	 * @returns {null|JSX.Element}
	 */
	render (props, state)
	{
		const runtime = props.runtime;
		const isActive = props.selected === props.runtime.id;

		return (
			<div class={classes({
				"_membership-runtime": true,
				"_membership-is-initially-opened": props.isFirstEntry,
				"_membership-is-last-entry": props.isLastEntry,
			})}
			>
				<button
					type="button"
					class="_membership-runtime-headline"
					onClick={props.onSelect}
				>
					{isActive ? ICON_RADIO_CHECKED : ICON_RADIO}
					<span>{runtime.title}</span>
				</button>
				<div class="_membership-runtime-content">
					<div class="_membership-runtime-data">
						<div class="_membership-runtime-data-section">
							<div class="_membership-runtime-data-headline">Mitgliedsbeitrag monatlich</div>
							<div class="_membership-runtime-price">{formatAmount(runtime.recurringFee)}</div>
							<div class="_membership-runtime-price-notice">Ab Mitgliedsbeginn monatlich</div>
							{null !== runtime.recurringDescription && (
								<div class="_membership-runtime-details">
									<button
										type="button"
										class="_membership-runtime-details-toggle"
										onClick={() => this.toggleDescription()}
									>Mehr Informationen
									</button>
									{/* eslint-disable-next-line react/no-danger */}
									<div
										class="_membership-runtime-details-content"
										dangerouslySetInnerHTML={{__html: runtime.recurringDescription}}
									/>
								</div>
							)}
						</div>
						<div class="_membership-runtime-data-section">
							<div class="_membership-runtime-data-headline">Startpaket</div>
							<div class="_membership-runtime-price">{formatAmount(runtime.entryFee)}</div>
							<div class="_membership-runtime-price-notice">Ab Mitgliedsbeginn einmalig</div>
							{null !== runtime.entryDescription && (
								<div class="_membership-runtime-details">
									<button
										type="button"
										class="_membership-runtime-details-toggle"
										onClick={() => this.toggleDescription()}
									>Mehr Informationen
									</button>
									{/* eslint-disable-next-line react/no-danger */}
									<div
										class="_membership-runtime-details-content"
										dangerouslySetInnerHTML={{__html: runtime.entryDescription}}
									/>
								</div>
							)}
						</div>
					</div>
				</div>
			</div>
		);
	}


	/**
	 * Toggles the description
	 *
	 * @private
	 */
	toggleDescription ()
	{
		const method = this.descriptionsOpened ? "slideUp" : "slideDown";
		const $elements = $(this.base).find("._membership-runtime-details-content");
		$elements.stop(true)[method]();
		this.descriptionsOpened = !this.descriptionsOpened;
	}
}
